import { ColorPaletteType, ThemeColorsType, ThemeTailwindType } from 'src/domains/common/themeColors';

export const pricedupColors: ThemeTailwindType = {
    '--primary': '48 100% 47%',
    '--menu-primary': '0 0% 100%',
    '--menu-secondary': '222 47% 11%',
};

const colorPalette: ColorPaletteType = {
    primary: '#131419',
    secondary: '#f2c300',
    tertiary: '#16b791',
    dark: '#020203',
    shade1: '#1c1d22',
    shade2: '#26272b',
    shade3: '#2f3035',
    shade4: '#393a3e',
    shade5: '#4c4c50',
    shade6: '#ececed',
    textDark: '#020203',
    textTertiary: '#16b791',
    white: '#ffffff',
};

export const themeColors: ThemeColorsType = {
    header: {
        bgColor: colorPalette.dark,
        bgColorSecondary: colorPalette.primary,
        bgColorTertiary: colorPalette.secondary,
        bgColorQuaternary: colorPalette.secondary,

        borderColor: colorPalette.secondary,
        borderColorSecondary: colorPalette.secondary,

        txtColor: colorPalette.white,
        txtColorSecondary: colorPalette.secondary,
        txtColorTertiary: colorPalette.dark,
        txtColorQuaternary: colorPalette.white,
    },
    buttons: {
        bgColor: colorPalette.secondary,
        txtColor: colorPalette.textDark,
    },
    input: {
        bgColor: colorPalette.shade6,
    },
    colorPicker: {
        colors: colorPalette,
        bgDefault: colorPalette.shade1,
        txtDefault: colorPalette.white,
    },
    anniversaryModal: {
        bgColor: '',
        bgColorSecondary: '',
        bgColorTertiary: '',
        txtColor: '',
        txtColorSecondary: '',
        txtColorTertiary: '',
    },
    loginPage: {
        bgColor: colorPalette.secondary,
    },
    traderChat: {
        bgColor: colorPalette.white,
        borderColor: '#d6e6f2',
        borderColorSecondary: '#ccc',
        txtColor: '#888',
    },
    compliancePopup: {
        bgColor: '#020203',
        txtColor: '#ffffff',
        bodyTxtColor: 'rgba(255, 255, 255, 0.8)',
        buttonBgColor: '#f2c300',
        buttonTxtColor: '#020203',
        secondaryBtnBgColor: 'rgba(255, 255, 255, 0.10)',
    },
};
